import { ApiError } from "../../services/apiService";

export const buildErrorAuth = (error, t) => {
  let errorMessage = t("auth.login.googleError");

  if (error instanceof ApiError) {
    switch (error.status) {
      case 400:
        errorMessage = t("login.invalidData");
        break;
      case 401:
        errorMessage = t("login.invalidCredentials");
        break;
      case 403:
        errorMessage = t("login.accountDenied");
        break;
      case 500:
        errorMessage = t("login.serverError");
        break;
      default:
        errorMessage = t("login.networkError");
    }
  } else {
    errorMessage = t("login.networkError");
  }

  return errorMessage;
};
